import React, { useEffect, useRef, useState } from 'react';
import '../css/LeafStorm.css';

function random(min, max) {
  return Math.random() * (max - min) + min;
}

function createLeaf(id) {
  return {
    id,
    right: `${random(0, 10)}vw`,
    animationDelay: '0s',
    animationDuration: `${random(8, 12)}s`, // longer duration, adjust as needed
  };
}

export default function LeafStorm({ active }) {
  const [leaves, setLeaves] = useState([]);
  const leafId = useRef(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (active) {
      intervalRef.current = setInterval(() => {
        setLeaves((prev) => [
          ...prev,
          createLeaf(leafId.current++)
        ]);
      }, 300); // Add a new leaf every 600ms
    } else {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [active]);

  // Remove leaf after animation ends
  const handleAnimationEnd = (id) => {
    setLeaves((prev) => prev.filter((leaf) => leaf.id !== id));
  };

  return (
    <div className="leaf-storm">
      {leaves.map((leaf) => (
        <img
          key={leaf.id}
          src="/pinkLeaf.png"
          className="falling-leaf"
          style={{
            right: leaf.right,
            animationDelay: leaf.animationDelay,
            animationDuration: leaf.animationDuration,
            zIndex: 0,
          }}
          alt="leaf"
          draggable={false}
          onAnimationEnd={() => handleAnimationEnd(leaf.id)}
        />
      ))}
    </div>
  );
}